<template>
  <section v-if="!this.loaded">
    <div v-if="lists" class="rounded border bg-white info-panel custom-table">
      <div class="table-responsive">
        <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 text-gray-800 mb-0" style="white-space: nowrap!important;">
          <thead>
          <tr class="fw-bold fs-8 text-gray-400">
            <th class="w-70px">ID</th>
            <th class="w-150px">Версия</th>
            <th class="w-100px">Создан</th>
            <th class="w-50px">Статус</th>
            <th class="text-center w-70px">Действие</th>
          </tr>
          </thead>
          <tbody v-if="lists.length >= 0">
          <tr class="align-middle">
            <td colspan="8" class="text-center">
              <div @click="newVersion" class="rounded border border-dashed pt-6 pb-6 cursor-pointer text-gray-400 border-gray-300 text-hover-primary border-hover-primary" style="border-width: 1px">Добавить</div>
            </td>
          </tr>
          <tr v-for="(item, key) in lists" :key="key" class="align-middle">
            <td v-html="item.id"></td>
            <td v-html="item.version"></td>
            <td v-html="item.created"></td>
            <td>
              <div v-if="false" class="form-check form-switch form-check-custom form-check-solid ms-1">
                <input @click="updateStatus(item.id, item.status)" class="form-check-input h-20px w-30px cursor-pointer" type="checkbox" name="status" v-model="item.status"/>
              </div>
            </td>
            <td class="text-center">
              <i @click="openModal(key, item, item.version)" class="ki-outline ki-notepad-edit fs-3 text-warning cursor-pointer d-inline-block" style="margin-top: 1px"></i>
              <i @click="deleteItem(key, item.id)" class="ki-outline ki-cross-square fs-3 text-danger cursor-pointer ms-3 d-inline-block" style="margin-top: 1px"></i>
            </td>
          </tr>
          </tbody>
        </table>
        <div v-if="lists.length <= 0" class="p-10 text-center text-gray-600">
          Нет записи
        </div>
      </div>
    </div>
  </section>
  <template v-else>
    <loader-full/>
  </template>
  <standard-modal modal-name="versionModal" :title="this.modal.title">
    <template v-slot:body v-if="this.modal.data !== null">
      <input v-if="this.modal.data.id" v-model="this.modal.data.id" type="hidden">
      <input-field
          v-model="this.modal.data.version"
          id="product.title"
          name="product_title"
          :required="true"
          placeholder="Версия"
          type="text"
          mb="5"
      />
      <select-field
          v-model="this.modal.data.status"
          id="product.status"
          name="product_status"
          :options="{0:'Неактивный', 1:'Активный'}"
          :required="true"
          placeholder="Статус"
          mb="5"
      />
      <div class="form-floating mb-5">
        <textarea v-model="this.modal.data.description" class="form-control form-control-solid" id="floatingTextarea2" style="min-height: 200px;"></textarea>
        <label for="floatingTextarea2">Описание</label>
      </div>
    </template>
    <template v-slot:footer v-if="this.modal.data !== null">
      <button
          :disabled="!modal.data.version.length > 0 || !modal.data.description.length > 0"
          @click="setProduct()"
          type="button"
          class="btn btn-sm btn-primary"
          v-html="this.modal.data.id ? 'Обновить' : 'Создать'"
      ></button>
    </template>
  </standard-modal>
</template>

<script>
import StandardModal    from '@/components/Modals/Universal/StandardModal';
import SelectField      from '@/components/Fields/SelectField';
import InputField       from '@/components/Fields/InputField';
import LoaderFull       from '@/components/Main/LoaderFull';
import axios            from 'axios';

export default {
  name: 'Versions',
  components: {SelectField, InputField, StandardModal, LoaderFull},
  data () {
    return {
      loaded: false,
      lists:  null,
      modal: {
        version: null,
        data:    null,
        key:     null
      }
    }
  },
  mounted() {
    this.getProducts()
  },
  methods: {
    getProducts () {
      this.loaded = true
      axios.get('/api/admin/version/get')
          .then(res => {
            this.lists = res.data
          })
          .catch(err => {console.log(err)})
          .finally(() => {this.loaded = false})
    },
    updateStatus(id, status) {
      const headers = {id:id, status:status}
      axios.post('/api/admin/version/status', headers)
    },
    openModal(key, data, version) {
      this.modal.key    = key
      this.modal.title  = version
      let clone         = structuredClone(data)
      clone.status      = clone.status ? 1 : 0
      this.modal.data   = clone
      new bootstrap.Modal('#versionModal', {}).show()
    },
    newVersion() {
      this.modal = {
        title: 'Создать',
        data: {
          description: '',
          version:     '',
          status:      1,
        },
        key: null
      }
      new bootstrap.Modal('#versionModal', {}).show()
    },
    setProduct() {
      const headers = this.modal.data
      axios.post('/api/admin/version/set', headers)
          .then(res => {
            this.modal.key === null ? this.lists.unshift(res.data[0]) : this.lists[this.modal.key] = res.data[0]
            this.modalHidden()
          })
          .catch(err => {console.log(err)})
    },
    deleteItem(key, id) {
      if (confirm(`Удалить ${this.lists[key].version}?`)) {
        this.loaded = true
        const headers = {id:id}
        axios.post('/api/admin/version/delete', headers)
            .then(() => {this.lists.splice(key, 1)})
            .catch(err => {console.log(err)})
            .finally(() => {this.loaded = false})
      }
    },
    modalHidden() {
      const myModalEl = document.getElementById('versionModal');
      const modal     = bootstrap.Modal.getInstance(myModalEl);
      if (modal) modal.hide()
    },
  }
}
</script>

<style></style>